import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// CD-362: Initialize auth state BEFORE mounting the app
// This ensures the router guard has correct auth state on page refresh
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore(pinia)
authStore.init().then(() => {
  app.mount('#app')
})
